module.exports = __webpack_public_path__ + "assets/img/d415-si.svg";